var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GridColumnChart',{attrs:{"loading":_vm.timeseries.loading,"resolved":_vm.timeseries.status.isResolved(),"timeseries":_vm.styledTimeseries,"time":_vm.timeseries.time,"chart-kind":_vm.gridColumn.params.chartKind,"legend":_vm.legend,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }